import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {AspectRatioCard} from '@homeaway/react-aspect-ratio-card';

import LazyLoad from '../lazy-load/LazyLoad';
import {LAZY_LOAD_OFFSET} from '../../../utils/constants';
import PlaceholderImage, {PlaceholderSvg} from './Placeholder';
import {CommonDescription, listingCaption} from './common';
import CardDescription from './CardDescription';
import ImageCardComponent from './ImageCard';
import DistanceFrom from './DistanceFrom';
import ListingBadges from './ListingBadges';

export function mapStateToProps(state) {
    const {options = {}, destination: {details = {}} = {}} = state;
    return {
        expandedTripboardButton: options.expandedTripboardButton,
        simpleName: details.simpleName,
    };
}

export class ListingsRatioCardComponent extends PureComponent {
    handleTripboardClick = (evt) => {
        evt.preventDefault();
    };

    renderCarouselDescription({caption, subcaption}) {
        const {
            instantBookable,
            link,
            price,
            review,
            breadcrumbs,
            distanceFrom,
            badges,
            loading,
        } = this.props;

        return (
            <div
                key={'content'}
                data-slot={'content'}
                className={'ListingsRatioCard__footer margin-top'}
            >
                <a href={link}>
                    {caption}
                    <CardDescription text={breadcrumbs} />
                    {subcaption && (
                        <CardDescription
                            text={subcaption}
                            className="CommonRatioCard__subcaption"
                        />
                    )}
                    {distanceFrom && <DistanceFrom text={distanceFrom} />}
                    {badges && badges.length && (
                        <ListingBadges items={badges} />
                    )}
                    <CommonDescription
                        loading={loading}
                        instantBookable={instantBookable}
                        price={price}
                        review={review}
                    />
                </a>
            </div>
        );
    }

    renderInnerCard({
        actionLocation,
        caption,
        currentIndex,
        images,
        offset,
        placeholder,
        position,
        subcaption,
        hasEdapFastPathEvents,
    }) {
        const imgProps = {
            actionLocation,
            currentIndex,
            position,
            images,
            hasEdapFastPathEvents,
        };

        return [
            <div
                key={'figure'}
                data-slot={'figure'}
                className={'ListingsRatioCard__img-container'}
            >
                <LazyLoad offset={offset} placeholder={placeholder}>
                    {imgProps.images[0] === '' ? (
                        <PlaceholderSvg />
                    ) : (
                        <ImageCardComponent {...imgProps} />
                    )}
                </LazyLoad>
                {this.renderTripboard()}
            </div>,
            this.renderCarouselDescription({caption, subcaption}),
        ];
    }

    renderCard({offset, placeholder, caption, subcaption}) {
        const {
            actionLocation,
            aspectRatio = '4x3',
            currentIndex,
            images = [],
            position,
            hasEdapFastPathEvents,
        } = this.props;

        return (
            <AspectRatioCard
                aspectRatio={aspectRatio}
                key={currentIndex}
                hasHover={false}
            >
                {this.renderInnerCard({
                    actionLocation,
                    caption,
                    currentIndex,
                    images,
                    offset,
                    placeholder,
                    position,
                    subcaption,
                    hasEdapFastPathEvents,
                })}
            </AspectRatioCard>
        );
    }

    renderTripboard() {
        const {
            actionLocation,
            tripleId,
            expandedTripboardButton,
            images = [],
            propertyName,
            review: {averageRating, reviewCount},
            simpleName,
            tripboardComponent: TripboardComponent,
        } = this.props;
        return (
            TripboardComponent && (
                <TripboardComponent
                    actionlocation={actionLocation}
                    listingId={tripleId}
                    expandedButton={expandedTripboardButton}
                    headline={propertyName}
                    newBoardName={simpleName}
                    onClick={this.handleTripboardClick}
                    averageRating={averageRating}
                    reviewCount={reviewCount}
                    thumbnailUrl={images[0]}
                />
            )
        );
    }

    render() {
        const {
            highlighted,
            isMobile,
            key,
            onClick,
            onMouseOut,
            onMouseOver,
            propertyName,
            toplineDescription: subcaption,
            noPrice,
        } = this.props;
        if (noPrice) return null;
        const className = highlighted
            ? 'ListingsRatioCard ListingsRatioCard--highlighted'
            : 'ListingsRatioCard';

        const placeholder = <PlaceholderImage />;

        const caption = listingCaption({
            toplineDescription: propertyName,
        });

        const offset = LAZY_LOAD_OFFSET[isMobile ? 'MOBILE' : 'DEFAULT'];

        return (
            <div
                key={key}
                role="button"
                onClick={onClick}
                className={className}
                onMouseOver={onMouseOver}
                onMouseOut={onMouseOut}
            >
                {this.renderCard({
                    className,
                    placeholder,
                    caption,
                    subcaption,
                    offset,
                })}
            </div>
        );
    }
}

export const ListingsRatioCard = connect(mapStateToProps)(
    ListingsRatioCardComponent
);

ListingsRatioCard.displayName = 'ListingsRatioCard';

export default ListingsRatioCard;
